import apiClient from './axios.config';
import { API_ENDPOINTS } from '../../constants';

export const budgetAPI = {
    // Budget Period Management
    createBudgetPeriod: (periodData) => apiClient.post(API_ENDPOINTS.BUDGET_PERIODS, periodData),
    submitBudgetPeriodForApproval: (periodId) => apiClient.post(API_ENDPOINTS.BUDGET_PERIOD_SUBMIT(periodId)),
    approveBudgetPeriod: (periodId, approvalData) => apiClient.post(API_ENDPOINTS.BUDGET_PERIOD_APPROVE(periodId), approvalData),
    getBudgetPeriods: (params = {}) => apiClient.get(API_ENDPOINTS.BUDGET_PERIODS, { params }),

    // Budget Management
    createBudget: (budgetData) => apiClient.post(API_ENDPOINTS.BUDGETS, budgetData),
    submitBudget: (budgetId) => apiClient.post(API_ENDPOINTS.BUDGET_SUBMIT(budgetId)),
    submitBudgetForApproval: (budgetId) => apiClient.post(API_ENDPOINTS.BUDGET_SUBMIT(budgetId)),
    financeApproveBudget: (budgetId, approvalData) => apiClient.post(API_ENDPOINTS.BUDGET_FINANCE_APPROVE(budgetId), approvalData),
    adminApproveBudget: (budgetId, approvalData) => apiClient.post(API_ENDPOINTS.BUDGET_ADMIN_APPROVE(budgetId), approvalData),
    getBudgets: (params = {}) => apiClient.get(API_ENDPOINTS.BUDGETS, { params }),
    getBudgetById: (budgetId) => apiClient.get(API_ENDPOINTS.BUDGET_BY_ID(budgetId)),
    updateBudget: (budgetId, budgetData) => apiClient.put(API_ENDPOINTS.BUDGET_BY_ID(budgetId), budgetData),
    deleteBudget: (budgetId) => apiClient.delete(API_ENDPOINTS.BUDGET_BY_ID(budgetId)),
};